<nav class="navbar navbar-expand-sm">
  <div class="container-fluid">
    <a (click)="redirectToDashboard()" style="cursor: pointer;">
      <img class="ms-sm-5" src="../../assets/images/logo.png" alt="Logo">
    </a>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0" style="display: flex; align-items:center; font-weight:600">
        <li class="nav-item p-2" style="margin-right: 15px;" *ngIf="loginStatus && !welcomeLogin">
          <a class="nav-link active" (click)="redirectToHome()" aria-current="page">Home</a>
        </li>
        <!-- <li *ngIf="atDashboard" class="nav-item p-2">
          <a class="nav-link active">About Us</a>
        </li> -->

        <!-- <li *ngIf="loginStatus" class="nav-item p-2">
          <a class="nav-link active" (click)="redirectToDetailRegister()" aria-current="page">Detailed Register</a>
        </li> -->
        <!-- <li *ngIf="loginStatus" class="nav-item p-2">
            <a href="login/detailed-register" class="nav-link">Detail Registration</a>
          </li> -->
        <!-- (click)="router.navigate(['/login/detailed-register'])" -->
        <!-- <div *ngIf="loginStatus" (click)="showAvatarDropdown = !showAvatarDropdown"
          class="nav-item p-2 userIconContainer">
          <i class="fa fa-user" style="color: rgb(231,236,237); font-size:18px" aria-hidden="true"></i>

          <div *ngIf="showAvatarDropdown" class="avatarDropdown">
            <div (click)="redirectToDetailRegister()" style="display: flex; align-items:center;">
              <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20">
                <path
                  d="M320 566v-60h320v60H320Zm0-160v-60h320v60H320ZM220 666h320q26.43 0 49.215 12Q612 690 628 710l112 146V236H220v430Zm0 250h490L581 747q-7.565-9.882-18.283-15.441Q552 726 540 726H220v190Zm520 60H220q-24 0-42-18t-18-42V236q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18Zm-520-60V236v680Zm0-190v-60 60Z"
                  fill="#ED1556" />
              </svg>
              <span style="margin-left:5px;">
                Profile
              </span>
            </div>

            <div (click)="logoutClick()" style="display: flex; align-items:center; margin-top:5px;">

              <svg id="Group_16557" data-name="Group 16557" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                viewBox="0 0 24 24">
                <path id="Path_6204" data-name="Path 6204" d="M0,0H24V24H0Z" fill="none" />
                <path id="Path_6205" data-name="Path 6205"
                  d="M4,18H6v2H18V4H6V6H4V3A1,1,0,0,1,5,2H19a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1Zm2-7h7v2H6v3L1,12,6,8Z"
                  fill="#ED1556" />
              </svg>
              <span style="margin-left:5px;">
                Logout
              </span>

            </div>
          </div>
        </div> -->


        <!-- <i class="fa fa-user-circle-o" aria-hidden="true"></i> -->

        <!-- <li *ngIf="loginStatus" (click)="showAvatarDropdown = !showAvatarDropdown" class="nav-item"
          style="margin-right:20px;">
          <a class="nav-link active">{{facilityName}}</a>
        </li> -->

        <li *ngIf="!loginStatus" class="nav-item p-2">
          <button type="button" class="btn login px-4"  (click)="toggleList()" [matMenuTriggerFor]="menu">LOGIN
            <svg class="svg-icon" width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.833374 0.333313L5.00004 4.49998L9.16671 0.333313H0.833374Z" fill="#ED1556"/>
              </svg>
              
          </button>

          <mat-menu #menu="matMenu">
            <button mat-menu-item  *ngFor="let item of menuItems" (click)="navigateToLogin(item)" style="
            font-size: 15px;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
            ">{{ item.name }}</button>
          </mat-menu>
        </li>

      

        <li *ngIf="!loginStatus" class="nav-item p-2">
          <button type="button" (click)=getStartedClick() class="btn get-started">GET STARTED</button>
        </li>
      </ul>

    </div>

    <div class="profileContainer d-sm-flex d-none" *ngIf="loginStatus" (click)="showAvatarDropdown = !showAvatarDropdown">
      <div class="nav-item p-2 userIconContainer">
        <i class="fa fa-user" style="color: rgb(231,236,237); font-size:18px" aria-hidden="true"></i>
      </div>
      <div style="margin-left: 10px; font-weight:600;">{{facilityName}}</div>

      <i *ngIf="showAvatarDropdown" class="fa fa-caret-up" style="font-size: 20px; cursor:pointer; margin-left: 10px;"
        aria-hidden="true"></i>
      <i *ngIf="!showAvatarDropdown" class="fa fa-caret-down"
        style="font-size: 20px; cursor:pointer; margin-left: 10px;" aria-hidden="true"></i>



      <div *ngIf="showAvatarDropdown" class="headerDropdown shadow">

        <div (click)="redirectToDetailRegister()" *ngIf="!adminLogin" class="profileText">
          <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20">
            <path
              d="M320 566v-60h320v60H320Zm0-160v-60h320v60H320ZM220 666h320q26.43 0 49.215 12Q612 690 628 710l112 146V236H220v430Zm0 250h490L581 747q-7.565-9.882-18.283-15.441Q552 726 540 726H220v190Zm520 60H220q-24 0-42-18t-18-42V236q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18Zm-520-60V236v680Zm0-190v-60 60Z"
              fill="gray" />
            <!-- fill="#ED1556" -->
          </svg>
          <span style="margin-left:10px;">
            Profile
          </span>
        </div>

        <div (click)="logoutClick()" class="logoutText">

          <svg id="Group_16557" data-name="Group 16557" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
            viewBox="0 0 24 24">
            <path id="Path_6204" data-name="Path 6204" d="M0,0H24V24H0Z" fill="none" />
            <path id="Path_6205" data-name="Path 6205"
              d="M4,18H6v2H18V4H6V6H4V3A1,1,0,0,1,5,2H19a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1Zm2-7h7v2H6v3L1,12,6,8Z"
              fill="gray" />
          </svg>
          <span style="margin-left:10px;">
            Logout
          </span>

        </div>
      </div>
    </div>
    <!-- <div *ngIf="loginStatus" class="logOutContainer" (click)="logoutClick()">
      LOGOUT
    </div> -->
  </div>
  <div class="profileContainer d-sm-none d-flex ms-auto me-3" *ngIf="loginStatus" (click)="showAvatarDropdown = !showAvatarDropdown">
    <div class="nav-item p-2 userIconContainer">
      <i class="fa fa-user" style="color: rgb(231,236,237); font-size:18px" aria-hidden="true"></i>
    </div>
    <div style="margin-left: 10px; font-weight:600;">{{facilityName}}</div>

    <i *ngIf="showAvatarDropdown" class="fa fa-caret-up" style="font-size: 20px; cursor:pointer; margin-left: 10px;"
      aria-hidden="true"></i>
    <i *ngIf="!showAvatarDropdown" class="fa fa-caret-down"
      style="font-size: 20px; cursor:pointer; margin-left: 10px;" aria-hidden="true"></i>



    <div *ngIf="showAvatarDropdown" class="headerDropdown shadow">

      <div (click)="redirectToDetailRegister()" *ngIf="!adminLogin" class="profileText">
        <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20">
          <path
            d="M320 566v-60h320v60H320Zm0-160v-60h320v60H320ZM220 666h320q26.43 0 49.215 12Q612 690 628 710l112 146V236H220v430Zm0 250h490L581 747q-7.565-9.882-18.283-15.441Q552 726 540 726H220v190Zm520 60H220q-24 0-42-18t-18-42V236q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18Zm-520-60V236v680Zm0-190v-60 60Z"
            fill="gray" />
          <!-- fill="#ED1556" -->
        </svg>
        <span style="margin-left:10px;">
          Profile
        </span>
      </div>

      <div (click)="logoutClick()" class="logoutText">

        <svg id="Group_16557" data-name="Group 16557" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
          viewBox="0 0 24 24">
          <path id="Path_6204" data-name="Path 6204" d="M0,0H24V24H0Z" fill="none" />
          <path id="Path_6205" data-name="Path 6205"
            d="M4,18H6v2H18V4H6V6H4V3A1,1,0,0,1,5,2H19a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1Zm2-7h7v2H6v3L1,12,6,8Z"
            fill="gray" />
        </svg>
        <span style="margin-left:10px;">
          Logout
        </span>

      </div>
    </div>
  </div>
</nav>
